import routerOptions0 from "/usr/src/app/content/n3-packages-849b228d-a260-4952-954d-6725ec0ef713/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}